import {
  useNavigate,
} from '@tanstack/react-router';
import React, {
  useEffect,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';
import {
  PersistentSessionsManager,
} from '@grafana/faro-web-sdk';

import {
  PendingProgress,
} from '#components/ui/progress/PendingProgress'; // Default loading delay component
import BGD from '#resources/images/backgrounds/BGD.png?url';
export function Logout(): React.ReactNode {
  const auth = useAuth();

  useEffect(() => {
    PersistentSessionsManager.removeUserSession();
    auth.signoutRedirect();
    // navigate({ to: '/' });
  }, []);
  return (
    (
      <div
        style={ {
          display: 'flex',
          textAlign: 'center',
          height: '100vh',
          width: '100vw',
          backgroundImage: `linear-gradient(245deg, rgb(17, 10, 34, 0) 0px, rgb(19, 11, 38, 0.98) 80%, rgb(32, 10, 43, 1) 100%), url("${BGD}")`,
        } }
      >
        <div
          style={ {
            height: '100vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(30px)',
            backgroundColor: 'rgb(255, 255, 255, 0.06)',
            position: 'absolute',
            zIndex: '1',
          } }
        >
          { auth.isLoading && (
            <PendingProgress />
          ) }
          { auth.error && !auth.isLoading && (
            <>
              <p>{ auth.error.message }</p>
            </>
          ) }
        </div>
      </div>
    )
  );
}

export default Logout;
